module.exports = __webpack_public_path__ + "img/energy-safe.7e25dee0.svg";